import { useSelector } from 'react-redux'

import { selectAppName } from 'root-redux/selects/common'
import {
  selectUserCountry,
  selectUserSubscriptionInfo,
} from 'root-redux/selects/user'

import { isWithdrawalEligible } from 'helpers/isWithdrawalEligible'

export const useIsWithdrawalEligible = (): boolean => {
  const appName = useSelector(selectAppName)
  const country = useSelector(selectUserCountry)
  const subscriptionInfo = useSelector(selectUserSubscriptionInfo)

  return isWithdrawalEligible({
    appName,
    country,
    startTimestamp: subscriptionInfo?.startDateTimestamp,
    wasWithdrawn: subscriptionInfo?.wasWithdrawn,
  })
}
